import axios from "axios";
import { API_URL, CLIENT_INSTANCE } from "config/env";

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
}

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Instance-Token": CLIENT_INSTANCE,
  },
});